import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../content";
import Reveal from "./Reveal";

export default function Testimonials() {
  return (
    <section id="opinie" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold tracking-tight text-[#242344] sm:text-3xl lg:text-4xl">
            Opinie uczestniczek
          </h2>
        </Reveal>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.08}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="flex h-full flex-col rounded-2xl border border-[#EAE6F0] bg-[#FAF8FC] p-6 transition-all duration-200 hover:-translate-y-1 hover:border-[#FFB3DA] hover:shadow-lg hover:shadow-[#FF008B]/5"
              >
                <Quote size={26} className="text-[#FF008B]" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-[#34343F]">
                  „{t.text}”
                </blockquote>
                <figcaption className="mt-5 border-t border-[#EAE6F0] pt-4">
                  <span className="block text-sm font-bold text-[#242344]">{t.signature}</span>
                  <span className="text-xs text-[#68677A]">{t.note}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
